import React from 'react'
const Icon = () => (
  <svg
    width="22"
    height="14"
    viewBox="0 0 22 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    id="MaskIcon"
  >
    <path
      d="M1 6C1 7.32608 1.52678 8.59785 2.46447 9.53553C3.40215 10.4732 4.67392 11 6 11C7.84771 11.0688 9.61454 11.7756 11 13C12.3855 11.7756 14.1523 11.0688 16 11C17.3261 11 18.5979 10.4732 19.5355 9.53553C20.4732 8.59785 21 7.32608 21 6V1H16C14.1523 1.06882 12.3855 1.77556 11 3C9.61454 1.77556 7.84771 1.06882 6 1H1V6Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 5C6.5 5 8 5.5 8 7C6 7 5 7 5 5ZM17 5C15.5 5 14 5.5 14 7C16 7 17 7 17 5Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default Icon
